var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_html.js
// module id = 100
// module chunks = 0